// extracted by mini-css-extract-plugin
export default {"section":"DiiaBlock_section","block":"DiiaBlock_block","blockTitle":"DiiaBlock_blockTitle","blockSubtitle":"DiiaBlock_blockSubtitle","error":"DiiaBlock_error"};